import { render, staticRenderFns } from "./sky-tabs-custom.vue?vue&type=template&id=4139feba&scoped=true"
import script from "./sky-tabs-custom.vue?vue&type=script&lang=js"
export * from "./sky-tabs-custom.vue?vue&type=script&lang=js"
import style0 from "./sky-tabs-custom.vue?vue&type=style&index=0&id=4139feba&prod&lang=scss&scoped=true"
import style1 from "./sky-tabs-custom.vue?vue&type=style&index=1&id=4139feba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4139feba",
  null
  
)

export default component.exports